import * as React from "react";

import { ContentBoxProps } from "@com.mgmtp.a12.widgets/widgets-core";
import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";

import { GeneralOverviewWidgetsMap } from "../modules/generalOverviewEngine/GeneralOverviewEngine";

export function FooterHeaderTitleDecorator(localizableKey: string) {
	return function FooterWithHeadingTitle(props: ContentBoxProps.FooterProps) {
		const { localizer } = React.useContext(LocalizerContext);
		return (
			<GeneralOverviewWidgetsMap.Footer
				{...props}
				headingTitle={localizer({ key: localizableKey })}
			></GeneralOverviewWidgetsMap.Footer>
		);
	};
}
